import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Departures from "./pages/Departures";
import Arrivals from "./pages/Arrivals";
import Error from "./pages/Error";
import ArrDep from "./pages/Arrdep";
import "./App.css"

function App() {
  return (
    <>
    <Router basename="/" >
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/arrivals" element={<Arrivals />} />
        <Route path="/departures" element={<Departures />} />
        <Route path="/arrdep" element={<ArrDep />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </Router>
  </>
  );
}

export default App;
